import storageService from './storageService';
import utilsService from './utilsService';

import VIDABOO_CONSTANTS from '../config/consts';

const service = {};

service.getMentorIdsUsingPeerUserIdOrMentorId = (
  peerUserIdOrMentorId = '',
  mentorsControlMapDto = {},
) => {
  let mentorIds = [];
  if (mentorsControlMapDto[peerUserIdOrMentorId]) {
    mentorIds.push(peerUserIdOrMentorId);
  } else {
    Object.values(mentorsControlMapDto).forEach((mentorCtrlDto) => {
      if (
        mentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
        peerUserIdOrMentorId
      ) {
        mentorIds.push(mentorCtrlDto.extendedMentorDto.mentorDto.mentorId);
      }
    });
  }
  return mentorIds;
};

service.getPeerUserIdUsingMentorId = (
  mentorOrUserId = '',
  mentorsControlMapDto = {},
) => {
  let peerUserId = null;
  if (mentorsControlMapDto[mentorOrUserId]) {
    // if mentorId is actually the id of mentor
    peerUserId =
      mentorsControlMapDto[mentorOrUserId].extendedMentorDto.mentorDto
        .mentorOwnerId;
  } else {
    // if mentorId is the userId -> it should exist in the widget
    Object.values(mentorsControlMapDto).forEach((mentorCtrlDto) => {
      if (
        mentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
        mentorOrUserId
      ) {
        peerUserId = mentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId;
      }
    });
  }
  return peerUserId;
};

service.getPeerUserIdUsingTeamMentorId = (
  teamMentorId = '',
  teamMentorsMapDto = {},
) => {
  let peerUserId = null;
  if (teamMentorsMapDto[teamMentorId]) {
    peerUserId =
      teamMentorsMapDto[teamMentorId].extendedMentorDto.mentorDto.mentorOwnerId;
  }
  return peerUserId;
};

service.getMentorIdUsingProfileName = (
  profileName = '',
  mentorsControlMapDto = {},
) => {
  const mentorDto = Object.values(mentorsControlMapDto).find(
    (widgetMentorControlDto) =>
      widgetMentorControlDto.extendedMentorDto.mentorDto.profileName ===
      profileName,
  );
  return mentorDto?.extendedMentorDto?.mentorDto?.mentorId;
};

service.getWidgetTeamMentorIds = (widgetDto) => {
  return Object.keys(widgetDto?.teamMentorsMapDto ?? {});
};

service.getFirstWidgetTeamMentorCtrlDto = (widgetDto) => {
  return Object.values(widgetDto?.teamMentorsMapDto ?? {})[0];
};

service.isConsentDomainNameExist = (domainName) => {
  let consentDomainNames = JSON.parse(storageService.get('consentDomainNames'));
  if (!Array.isArray(consentDomainNames)) {
    consentDomainNames = [];
  }
  return consentDomainNames.includes(domainName);
};

service.setConsentDomainName = (domainName) => {
  let consentDomainNames = JSON.parse(storageService.get('consentDomainNames'));
  if (!Array.isArray(consentDomainNames)) {
    consentDomainNames = [];
  }
  if (!service.isConsentDomainNameExist(domainName)) {
    consentDomainNames.push(domainName);
  }
  storageService.setObj('consentDomainNames', consentDomainNames);
};

service.addDefaultValuesToWidgetDto = (widgetDto, updateOnlyStyles) => {
  const saturation = 100;
  const lightness = 35;

  if (!widgetDto.widgetAppCtrlDto.closedWidgetType) {
    widgetDto.widgetAppCtrlDto.closedWidgetType =
      VIDABOO_CONSTANTS.WIDGET_MASK_TYPE.LOGO;
  }
  if (!widgetDto.widgetAppCtrlDto.style) {
    widgetDto.widgetAppCtrlDto.style = {};
  }
  if (!widgetDto.widgetAppCtrlDto.style.locationOnScreen) {
    widgetDto.widgetAppCtrlDto.style.locationOnScreen =
      VIDABOO_CONSTANTS.WIDGET_LOCATION.BOTTOM_RIGHT;
  }
  if (!widgetDto.widgetAppCtrlDto.style.themePreset) {
    widgetDto.widgetAppCtrlDto.style.themePreset =
      VIDABOO_CONSTANTS.MAIN_THEME.CONSOLTO_LITE.type;
  }

  utilsService.parseStyleObject(widgetDto.widgetAppCtrlDto.style);
  utilsService.assignThemeCustomizationValues(widgetDto.widgetAppCtrlDto.style);

  for (const mentorId in widgetDto.mentorsControlMapDto) {
    const extendedMentorDto =
      widgetDto.mentorsControlMapDto[mentorId].extendedMentorDto;
    utilsService.parseStyleObject(
      extendedMentorDto.mentorDto.appControlDto.style,
    );
    if (updateOnlyStyles) continue;

    //add first name and last name
    let nameArr = extendedMentorDto.mentorDto.displayName
      .trim()
      .replace(/\+$/, '')
      .split(/\s+/);
    if (nameArr[0] && nameArr[1]) {
      extendedMentorDto.firstName = nameArr[0];
      extendedMentorDto.lastName = nameArr[1];
    } else if (nameArr[0]) {
      extendedMentorDto.firstName = nameArr[0];
    }

    //add mentor pill color
    const hue = (extendedMentorDto.mentorDto.serialNum * 137.5) % 360;
    extendedMentorDto.mentorPillColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  for (const teamMentorId in widgetDto.teamMentorsMapDto) {
    const extendedMentorDto =
      widgetDto.teamMentorsMapDto[teamMentorId].extendedMentorDto;
    utilsService.parseStyleObject(
      extendedMentorDto.mentorDto.appControlDto.style,
    );
    if (
      widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
      VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT
    )
      extendedMentorDto.mentorDto.appControlDto.widgetActionSelector = false;
  }
};

service.getMentorChatPillName = (extendedMentorDto = {}) => {
  let mentorPillName = '';
  const firstName = extendedMentorDto.firstName;
  const lastName = extendedMentorDto.lastName;

  if (firstName && lastName) {
    mentorPillName = firstName[0] + lastName[0];
  } else if (firstName) {
    mentorPillName = firstName[0];
  } else {
    console.debug(extendedMentorDto);
  }
  return mentorPillName.toUpperCase();
};

service.getExMentorDtoByMentorOwnerId = (
  mentorOrTeamMentorOwnerId = null,
  widgetDto = {},
) => {
  let exMentorDto = null;
  if (widgetDto) {
    Object.values(widgetDto.mentorsControlMapDto).forEach((mentorCtrlDto) => {
      if (
        mentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
        mentorOrTeamMentorOwnerId
      ) {
        exMentorDto = mentorCtrlDto.extendedMentorDto;
      }
    });
    if (!exMentorDto) {
      Object.values(widgetDto.teamMentorsMapDto).forEach(
        (teamMentorCtrlDto) => {
          if (
            teamMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
            mentorOrTeamMentorOwnerId
          ) {
            exMentorDto = teamMentorCtrlDto.extendedMentorDto;
          }
        },
      );
    }
  }
  return exMentorDto;
};

const multiWidgetService = {...service};
export default multiWidgetService;
